import { sendRequest } from "../libs/axiosConfig";

export const getSectorsCategoriesApi = async () => {
  const res = await sendRequest({
    url: "/api/v1/sectors/categories",
    method: "GET",
  });
  return res;
};


export const getSectorsCategoryByIdApi = async (sectorCategoryId) => {
  const res = await sendRequest({
    url: `/api/v1/sectors/categories/${sectorCategoryId}`,
    method: "GET"
  });
  return res;
};

export const getSectorByIdApi = async (sectorId) => {
  const res = await sendRequest({
    url: `/api/v1/sectors/sectordetails/${sectorId}`,
    method: "GET",
  });
  return res;
};

export const getSectorWiseByIdApi = async (sectorId) => {
  const res = await sendRequest({
    url: `/api/v1/sectors/sectorwise/${sectorId}`,
    method: "GET",
    moduleName: "SME Activity"
  });
  return res;
};

export const getSectorObservationsApi = async (payload) => {
  const res = await sendRequest({
    url: `/api/v1/observations`,
    method: "Post",
    body: { ...payload },
  });
  return res;
};


export const getSectorCategoriesApi = async () => {
  const res = await sendRequest({
    url: `/api/v1/sector/categories`,
    method: "GET",
  });
  return res;
};


export const getAllSectorsApi = async (categoryName) => {
  const res = await sendRequest({
    url: `/api/v1/sectors?category=${encodeURIComponent(categoryName)}`,
    method: "GET",
  });
  return res;
};


export const getPopularSectorsApi = async () => {
  const res = await sendRequest({
    url: `/api/v1/sectors/popular`,
    method: "GET",
  });
  return res;
};

export const getFindSupplierApi = async (sectorId) => {
  const res = await sendRequest({
    url: `/api/v1/sectors/clients/${sectorId}`,
    method: "GET",
  });
  return res;
};
  export const getStatesApi = async () => {
    const res = await sendRequest({
      url: `/api/v1/category/states`,
      method: "GET",
      
    });

    return res;
  }

  export const getCategoryExpenditureAnalysisApi = async (payload) => {
  const res = await sendRequest({
    url: `/api/v1/category/years`,
    method: "POST",
    body: payload,
  });

  return res;
};


export const getImportDataApi = async () => {
  try {
    const res = await sendRequest({
      url: `/api/v1/mapped-import`,
      method: "GET",
    });
    return {
      status: true,
      data: res.data,
    };
  } catch (err) {
    return {
      status: false,
      message: err?.response?.data?.message || err.message || "Request failed",
    };
  }
};

export const getexportDataApi = async () => {
  try {
    const res = await sendRequest({
      url: `/api/v1/mapped-export`,
      method: "GET",
    });
    console.debug("API call succeeded:", res);
    return res.data; 
  } catch (err) {
    console.error("API call failed:", err);
    throw new Error("Network or server error while fetching export data");
  }
};
